import store from '@/store'

const errorPages = [
  400,
  403,
  404,
  409,
  500,
  503,
]

export default function redirectError(error) {
  if (error) {
    const { status } = error.response
    if (errorPages.includes(status)) {
      store.commit('app/SET_ERROR_CODE', status)
      // router.push({ name: `error-${status}`, params: { route } })
    }
  }
}
